const DB_NAME = 'TodoE-DB';
const STORE_NAME = 'kv';
const DB_VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);

    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    req.onsuccess = () => resolve(req.result);
    req.onerror = (e) => reject(e);
  });
}

// --- SET più valori ---
export async function setValuesInIndexedDB(obj) {
  // obj = { key1: value1, key2: value2, ... }
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    for (const [key, value] of Object.entries(obj)) {
      store.put(value, key);
    }
    tx.oncomplete = () => resolve(true);
    tx.onerror = (e) => reject(e);
  });
}

// --- GET più valori ---
export async function getValuesFromIndexedDB(keys) {
  // keys = [key1, key2, ...]
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);

    const results = {};
    let pending = keys.length;

    if (pending === 0) resolve(results);

    keys.forEach((key) => {
      const req = store.get(key);
      req.onsuccess = () => {
        results[key] = req.result;
        if (--pending === 0) resolve(results);
      };
      req.onerror = (e) => reject(e);
    });
  });
}

export async function deleteValuesFromIndexedDB(keys) {
  // keys = [key1, key2, ...]
  if (!Array.isArray(keys) || keys.length === 0) {
    return false;
  }
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    let pending = keys.length;

    keys.forEach(key => {
      const req = store.delete(key);
      req.onsuccess = () => {
        pending--;
        if (pending === 0) {
          resolve(true);
        }
      };
      req.onerror = (e) => {
        reject(e);
      };
    });
  });
}
